import { isNumeric } from '@utils';

const getExpressLink = ({ donationLink, amount }) => {
  if (!donationLink || !amount || !amount.value) return null;
  const isNumber = amount.value && isNumeric(amount.value);
  return isNumber ? donationLink : donationLink.replace(/(\?&)?express_lane=true(&)?/g, '');
};

export default getExpressLink;
